import axios from 'axios';
import { useState } from 'react';
import { GENERATE_EMAIL_API_URL } from '../utils/apiUrls';
import { getAccessToken } from '../utils/token-service';

const useEmailSubjectApiCall = () => {
	const [loading, setLoading] = useState(false);
	const [output, setOutput] = useState('');

	const handleSubmit = async (urlText: any, tone: any, wordLimit: any) => {
		setLoading(true);
		let data = {
			url: urlText,
			tone: tone,
			word_limit: wordLimit,
		};

		const accessToken = await getAccessToken();
		let config = {
			method: 'post',
			maxBodyLength: Infinity,
			url: GENERATE_EMAIL_API_URL,
			headers: {
				'Content-Type': 'application/json',
				Authorization: `Bearer ${accessToken}`,
			},
			data: data,
		};

		try {
			const result = await axios.request(config);
			setOutput(result.data.output);
		} catch (error) {
			console.log('Error calling API:', error);
		} finally {
			setLoading(false);
		}
	};

	return { loading, output, handleSubmit };
};

export default useEmailSubjectApiCall;
